import PropTypes from 'prop-types';

import { STATUS } from '@zenbusiness/application-commons-ecommerce/useSubmitOrder';
import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';

import PageHeader from '#client/components/PageHeader';
import { useCheckoutContext } from '#client/pages/Checkout/hooks/useCheckoutContext';

function Header({ messageKey, showSubtitle }) {
  const [{ placeOrder }] = useCheckoutContext();

  const subtitle = showSubtitle && (
    <>
      <FormattedMessage id={`${messageKey}.subtitle`} />
      {/* To avoid alpha color values on emoji  */}
      <Box color="common.black" component="span">
        {' 🎉'}
      </Box>
    </>
  );

  return (
    <PageHeader
      disableBack={placeOrder.status === STATUS.PENDING}
      subtitle={subtitle}
      title={<FormattedMessage id={`${messageKey}.title`} />}
    />
  );
}

Header.propTypes = {
  messageKey: PropTypes.string,
  showSubtitle: PropTypes.bool
};

export default Header;
